import fp from "lodash/fp";

export default function stripUndefined(values: any): { [key: string]: string } {
  return fp.pickBy(fp.identity, values);
}
